<!--
 * @Author: your name
 * @Date: 2023-01-29 12:48:25
 * @LastEditors: your name
 * @LastEditTime: 2023-03-06 10:53:19
 * @FilePath: /developer-black/src/app/routes/project/edit/lot/edit-lot/link-package/link-package.component.html
 * @Description:
 *
 * Copyright (c) 2023 by 用户/公司名, All Rights Reserved.
-->
<div
  style="padding: 20px; display: flex; align-items: center;  background: #0E0D0D; border-bottom: 1px solid #ddd;color: #dedede;">
  Choose &nbsp;package(s) &nbsp;for &nbsp;lot<span
  style="color: #fff; background: #102c65; padding: 4px 12px; border-radius: 13px; font-size: 12px; margin-left: 10px; ">{{data.lot.lotNumber}}</span>
</div>
<!--<div style="padding: 20px;  font-size: 14px; display: flex">-->
<!--    <mat-icon style="color: #3C50E0">info</mat-icon>-->
<!--    <div style="margin-left: 10px">-->
<!--        Note: <em>{{data.project.name}}</em>&nbsp; is a house/townhouse/apartment built on the certain lots of <em>{{data.project.name}}</em>.<br>It can be viewed as a child project associated with <em>{{data.project.name}}</em>.-->
<!--    </div>-->
<!--</div>-->
<div style="max-height: 80vh; overflow-y: scroll" class="linkpackagenew">
  <table mat-table [dataSource]="dataSource" style="width: 100%">
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="packageName">
      <th mat-header-cell *matHeaderCellDef>Package Name</th>
      <!--      <div *ngFor="let packages of packageProperties">-->
      <!--        <td mat-cell *matCellDef="let element">-->
      <!--          <div *ngFor="let item of packages.properties">-->
      <!--            {{item.unitNum}}-->
      <!--          </div>-->
      <!--        </td>-->
      <!--      </div>-->
      <!--      <td mat-cell *matCellDef="let element">-->
      <!--&lt;!&ndash;        <div *ngFor="let item of element.property">&ndash;&gt;-->
      <!--&lt;!&ndash;          {{item.unitNum}}&ndash;&gt;-->
      <!--&lt;!&ndash;        </div>&ndash;&gt;-->
      <!--      </td>-->
      <td mat-cell *matCellDef="let element">
        <!--        <div *ngFor="let item of element.properties">-->
        <!--          {{item.unitNum}}-->
        <!--        </div>-->
        {{element.unitNum}}
      </td>
    </ng-container>
    <ng-container matColumnDef="packagePrice">
      <th mat-header-cell *matHeaderCellDef>Building Price</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.price > 0">
<!--          {{element.properties[0] ? (element.properties[0].price | currency: '':'symbol':'3.0') : '-'}}-->
          {{element.price | currency: '':'symbol':'3.0'}}
        </ng-container>
        <ng-container *ngIf="element.price === 0">
          -
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="property">
      <th mat-header-cell *matHeaderCellDef>Property</th>
      <td mat-cell *matCellDef="let element">
        <ng-container>
<!--          <div *ngFor="let p of element">Bed - {{p.bedRoom}} &nbsp;&nbsp; Bath - {{p.bathRoom}}-->
<!--            &nbsp;&nbsp; Car - {{p.carParking}}</div>-->
          <div>Bed - {{element.bedRoom}} &nbsp;&nbsp; Bath - {{element.bathRoom}}
            &nbsp;&nbsp; Car - {{element.carParking}}</div>
        </ng-container>
<!--        <ng-container *ngIf="!element || element.length === 0">-->
<!--          - -->
<!--        </ng-container>-->
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
    </tr>
  </table>

</div>
<div style="display: flex; justify-content: flex-end; padding: 16px 20px; border-top: 1px solid #ddd">
  <button mat-button style="color: white; background: #5cba50" (click)="confirm()">Confirm</button>
</div>
